import { useMemo } from 'react';

import * as tracking from './tracking';

import { EFieldName } from '../../constants';
import { ETypeChangeInput, IOfferForAnalytic } from './types';

export const useTracking = () => {
  return useMemo(() => {
    const trackScrollAndStopOnBlock = () => {
      tracking.trackScrollAndStopOnBlock();
    };

    const trackClickOnTargetButton = () => {
      tracking.trackClickOnTargetButton();
    };

    const trackEditFieldValues = (paramInput: ETypeChangeInput, paramValue: number | string, el: EFieldName) => {
      tracking.trackEditFieldValues({ el, paramInput, paramValue });
    };

    const trackShowEmptyListing = () => {
      tracking.trackShowEmptyListing();
    };

    const trackClickEmptyListingBtn = () => {
      tracking.trackClickEmptyListingBtn();
    };

    const trackShowErrorListing = () => {
      tracking.trackShowErrorListing();
    };

    const trackClickRefresh = () => {
      tracking.trackClickRefresh();
    };

    const trackShowOffers = (offersList: IOfferForAnalytic[]) => {
      tracking.trackShowOffers({ offersList });
    };

    const trackClickPskTooltip = () => {
      tracking.trackClickPskTooltip();
    };

    const trackClickOnOffer = (listNumber: number, offerParams: IOfferForAnalytic) => {
      tracking.trackClickOnOffer({ listNumber, offerParams });
    };

    const trackShowModal = (offer: IOfferForAnalytic) => {
      tracking.trackShowModal({ offer });
    };

    const trackClickOnCreateMortgage = (offer: IOfferForAnalytic | null) => {
      tracking.trackClickOnCreateMortgage({ offer });
    };

    const trackClickOnShowPhone = (offer: IOfferForAnalytic | null) => {
      tracking.trackClickOnShowPhone({ offer });
    };

    const trackOpenPhoneAuthModal = () => {
      tracking.trackOpenPhoneAuthModal();
    };

    const trackOpenSmsAuthModal = () => {
      tracking.trackOpenSmsAuthModal();
    };

    const trackClickOnRepeatSms = () => {
      tracking.trackClickOnRepeatSms();
    };

    const trackClickConfirmPhone = () => {
      tracking.trackClickConfirmPhone();
    };

    const trackAgreeToCommercial = () => {
      tracking.trackAgreeToCommercial();
    };

    const trackClickConfirmSms = () => {
      tracking.trackClickConfirmSms();
    };

    const trackAuthorizationSuccess = () => tracking.trackAuthorizationSuccess();

    return {
      trackScrollAndStopOnBlock,
      trackClickOnTargetButton,
      trackEditFieldValues,
      trackShowEmptyListing,
      trackClickEmptyListingBtn,
      trackShowErrorListing,
      trackClickRefresh,
      trackShowOffers,
      trackClickPskTooltip,
      trackClickOnOffer,
      trackShowModal,
      trackClickOnCreateMortgage,
      trackClickOnShowPhone,
      trackAuthorizationSuccess,
      trackOpenPhoneAuthModal,
      trackOpenSmsAuthModal,
      trackClickOnRepeatSms,
      trackClickConfirmPhone,
      trackAgreeToCommercial,
      trackClickConfirmSms,
    };
  }, []);
};
